import React, { Component } from 'react';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import get from 'lodash/get'
import map from 'lodash/map'
import Bem from 'bemHelper';
import { emit } from 'helpers/global-events';
import { I18nHoc, Trans } from 'helpers/i18n';
import { authConnect, perms } from 'auth';
import apiDecorator from 'api/api-decorator';
import DataProvider from 'api/data-provider';
import { reportError } from 'api/api-errors';
import Form from 'containers/form';
import EditorLight from 'containers/form/extended/editor-light';
import Loader from 'components/loader';
import Accordion from 'components/accordion';
import Link from 'components/link';

import { saveTime } from './topic-info';

import linksForum from 'src-sites/forum/links';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';
import 'styles/forum/common/_post-list.scss';

import translates from './reply-post-i18n';

const classesBemForm = new Bem('modalContentAdmin');
const bemClassesPostControl = new Bem('postControlForum');
const bemClassesPosts = new Bem('postList');

// Show button for replay to topic/post.
@authConnect()
@apiDecorator
@I18nHoc(translates())
export default class ReplyPostButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    router: routerShape,
    checkPermission: PropTypes.func,
    params: PropTypes.shape({
      title: PropTypes.string
    }),
    data: PropTypes.shape({}),
    post_id: PropTypes.number,
    buttonTitle: PropTypes.string,
    onPostSubmit: PropTypes.func,
    quote: PropTypes.bool
  };

  // Action for closing modal window
  static contextTypes = {
    close: PropTypes.func
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.formReplyPost = this.formReplyPost.bind(this);
    this.cutPostText = this.cutPostText.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.mounted = false;
    this.quoteText = '';

    this.state = {
      postTextCutted: !props.quote
    };
  }

  componentDidMount() {
    this.mounted = true;

    if (!this.state.postTextCutted) this.cutPostText();
  }

  componentWillUnmount() {
    this.mounted = false;
    clearTimeout(this.delay);
  }

  onSubmit(submittedData = {}) {
    emit('updateClubPosts');
    const { data = {}, post_id, onPostSubmit } = this.props;

    if (!post_id) {
      this.api.get(`action/forum/actions-find-page/get-last-post?type=posts&id=${submittedData.post_id}`)
        .then((payload) => {
          const href = `${payload.lastPageUrl}#post-${submittedData.post_id}`;
          saveTime.call(this, data.topic_id);
          const isLastPage = get(this, 'props.router.location.pathname') === payload.lastPageUrl;
          if (typeof onPostSubmit === 'function') {
            onPostSubmit(isLastPage ? submittedData.post_id : null);
          }
          if (href && !isLastPage) {
            this.props.router.push(href);
          }
        })
        .catch(error => reportError(error));
    } else {
      if (onPostSubmit) onPostSubmit();
    }
  }

  cutPostText() {
    const { data = {} } = this.props;
    this.quoteText = '';

    this.api.post('action/forum/actions-post-remove-tags/remove', {
      postData: {
        postId: data.post_id
      }
    })
      .then((respond) => {
        this.quoteText = (
          `<blockquote><p><span class="quoteNick__text">${data.forum_nick || 'Anonymous'}</span></p>${respond.postText || ''}</blockquote><p class="quoteAnswer"></p>`
        );

        if (this.mounted) this.setState({ postTextCutted: true });
      })
      .catch(error => reportError(error));
  }

  renderUsersWarning = ({data}) => {
    if (!data || !data.length) return <span />;

    const { i18n } = this;
    const warnings = get(data, '[0].warnings') || [];
    const linkProps = {
      builder: linksForum.sectionTopic,
      builderProps: {
        topicUrl: '/domik-rules-t19531.html',
        topic_title: i18n('forumRules'),
        hash: '#p267480'
      },
      noRedirector: true,
      blank: false
    };
    const linkToRules = (
      <>
        <Trans lang="ru">
          <span {...bemClassesPosts('text', 'red')} children="У вас Предупреждение. " />
          <span {...bemClassesPosts('text')} children="Пожалуйста соблюдайте " />
          <Link
            {...bemClassesPosts('link')}
            {...linkProps}
            inlineBlock
          >
            <span {...bemClassesPosts('linkContent')}>
              <span {...bemClassesPosts('text', 'link')} children="правила форума" />
            </span>
          </Link>
        </Trans>
        <Trans lang="ua">
          <span {...bemClassesPosts('text', 'red')} children="У вас Попередження. " />
          <span {...bemClassesPosts('text')} children="Будь ласка дотримуйтесь " />
          <Link
            {...bemClassesPosts('link')}
            {...linkProps}
            inlineBlock
          >
            <span {...bemClassesPosts('linkContent')}>
              <span {...bemClassesPosts('text', 'link')} children="правил форуму" />
            </span>
          </Link>
        </Trans>
      </>
    );

    return (
      <Accordion
        {...bemClassesPosts('accordion', 'caution')}
        panelTopic={linkToRules}
      >
        <panel {...bemClassesPosts('panel')}>
          <div {...bemClassesPosts('accordionContent')}>
            <div {...bemClassesPosts('hint')}>
              <div
                {...bemClassesPosts('text', 'mb')}
                children={i18n('warningTopic', { placeholder: get(data, '[0].topic_title') })}
              />
              {map(warnings, (warning, key) => {
                return (
                  <div
                    key={key}
                    {...bemClassesPosts('text', 'mb')}
                    children={get(warning, 'value')}
                  />
                );
              })}
              <div {...bemClassesPosts('text', 'mb')} children={i18n('during30days')} />
              <div {...bemClassesPosts('text')} children={i18n('beKind')} />
            </div>
          </div>
        </panel>
      </Accordion>
    );
  }

  // Show form replay to topic.
  formReplyPost(data) {
    const { i18n } = this;
    const { post_id = null, checkPermission } = this.props;
    const otherProps = {
      defaultValues: {
        forum_id: data.forum_id,
        topic_id: data.topic_id,
        post_title: data.post_title,
        post_text: this.quoteText
      }
    };
    const posterId = get(this, 'props.auth.id');

    return (
      <Form
        {...bemClassesPostControl('form')}
        updateEvent="updatePosts"
        controller="forum/post-form"
        entityId={post_id}
        onSubmit={this.onSubmit}
        showPopupValidationMessages
        hFull
        {...otherProps}
      >
        <EditorLight
          {...classesBemForm('editor')}
          dataBind="post_text"
          sendEnable
          autoFocus
          inForm
        />
        {(checkPermission(perms.FORUM_PREMODERATION_POST) || data.on_moderation) &&
          <div {...bemClassesPosts('hint')}>
            <span {...bemClassesPosts('text')} children={i18n('postOnModeration')} />
          </div>
        }
        <DataProvider
          url="forum/users-warning"
          query={{
            posterId,
            duringPeriod: true
          }}
          queryJson
          renderer={this.renderUsersWarning}
        />
      </Form>
    );
  }

  render() {
    const { className, data } = this.props;

    return (
      // Replay to topic
      <div key="showReplyForm" className={className}>
        {!this.state.postTextCutted
          ? <div className="loaderContainer"><Loader formMainSize /></div>
          : this.formReplyPost(data)
        }
      </div>
    );
  }
}
